import { type FC } from 'react';

import { Icon } from '@vakantiesnl/components/src/atoms/Icon';
import { type Awards } from '@vakantiesnl/types';

import { useStyles } from './AwardLabel.style';

export const AwardLabel: FC<{ awardType: Awards.AwardType }> = ({ awardType }) => {
	const { classes } = useStyles({ awardType });

	return (
		<div className={classes.awardLabelContainer}>
			<Icon type="award" />
		</div>
	);
};
